import { normalize } from 'normalizr'
import { category } from '../adapters/categorySchema'
import { organization } from '../adapters/organizationSchema'
import { rate } from '../adapters/rateSchema'
import * as ActionTypes from './actionTypes'

// categories actions
export const h24_fetchCategoriesSuccess = data => ({
    type: ActionTypes.H24_CATEGORIES_FETCH_SUCCESS,
    ...data
})

export const h24_fetchCategoriesFailure = error => ({
    type: ActionTypes.H24_CATEGORIES_FETCH_FAILURE,
    error
})

export const h24_saveCategoriesSuccess = data => ({
    type: ActionTypes.H24_CATEGORIES_SAVE_SUCCESS,
    data: normalize(data, category)
})

export const h24_saveCategoriesFailure = error => ({
    type: ActionTypes.H24_CATEGORIES_SAVE_FAILURE,
    error
})

export const h24_deleteCategorySuccess = id => ({
    type: ActionTypes.H24_CATEGORIES_DELETE_SUCCESS,
    data: id
})

export const h24_deleteCategoryFailure = error => ({
    type: ActionTypes.H24_CATEGORIES_DELETE_FAILURE,
    error
})

export const h24_importCategoriesSuccess = data => ({
    type: ActionTypes.H24_CATEGORIES_IMPORT_SUCCESS,
    ...data
})

export const h24_importCategoriesFailure = error => ({
    type: ActionTypes.H24_CATEGORIES_IMPORT_FAILURE,
    error
})

// organizations actions
export const h24_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.H24_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const h24_fetchOrganizationsFailure = error => ({
    type: ActionTypes.H24_ORGANIZATIONS_FETCH_FAILURE,
    error
})

export const h24_saveOrganizationsSuccess = data => ({
    type: ActionTypes.H24_ORGANIZATIONS_SAVE_SUCCESS,
    data: normalize(data, organization)
})

export const h24_updateOrganizationsFailure = error => ({
    type: ActionTypes.H24_ORGANIZATIONS_UPDATE_FAILURE,
    error
})

export const h24_updateOrganizationsSuccess = data => ({
    type: ActionTypes.H24_ORGANIZATIONS_UPDATE_SUCCESS,
    data: normalize(data, organization)
})

export const h24_deleteOrganizationSuccess = id => ({
    type: ActionTypes.H24_ORGANIZATIONS_DELETE_SUCCESS,
    data: id
})

export const h24_deleteOrganizationFailure = error => ({
    type: ActionTypes.H24_ORGANIZATIONS_DELETE_FAILURE,
    error
})

export const h24_saveOrganizationsFailure = error => ({
    type: ActionTypes.H24_ORGANIZATIONS_SAVE_FAILURE,
    error
})

// rates actions
export const h24_fetchRatesSuccess = data => ({
    type: ActionTypes.H24_RATES_FETCH_SUCCESS,
    ...data
})

export const h24_fetchRatesFailure = error => ({
    type: ActionTypes.H24_RATES_FETCH_FAILURE,
    error
})

export const h24_saveRatesSuccess = data => ({
    type: ActionTypes.H24_RATES_SAVE_SUCCESS,
    data: normalize(data, rate)
})

export const h24_saveRatesFailure = error => ({
    type: ActionTypes.H24_RATES_SAVE_FAILURE,
    error
})

export const h24_deleteRateSuccess = id => ({
    type: ActionTypes.H24_RATES_DELETE_SUCCESS,
    data: id
})

export const h24_deleteRateFailure = error => ({
    type: ActionTypes.H24_RATES_DELETE_FAILURE,
    error
})

export const h24_importRatesSuccess = data => ({
    type: ActionTypes.H24_RATES_IMPORT_SUCCESS,
    ...data
})

export const h24_importRatesFailure = error => ({
    type: ActionTypes.H24_RATES_IMPORT_FAILURE,
    error
})


// currentOrganization actions
export const h24_changeCurrentOrganization = id => ({
    type: ActionTypes.H24_CURRENT_ORGANIZATION_CHANGE,
    data: id
})

// sync actions
export const h24_pushYearPricesRequest = () => ({
    type: ActionTypes.H24_PUSH_YEAR_PRICES_REQUEST
})
export const h24_pushYearPricesSuccess = () => ({
    type: ActionTypes.H24_PUSH_YEAR_PRICES_SUCCESS
})
export const h24_pushYearPricesFailure = () => ({
    type: ActionTypes.H24_PUSH_YEAR_PRICES_FAILURE
})

export const h24_pushYearRestrictionsRequest = () => ({
    type: ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_REQUEST
})
export const h24_pushYearRestrictionsSuccess = () => ({
    type: ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_SUCCESS
})
export const h24_pushYearRestrictionsFailure = () => ({
    type: ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_FAILURE
})

export const h24_inventoryAvailabilityRequest = () => ({
    type: ActionTypes.H24_INVENTORY_AVAILABILITY_REQUEST
})
export const h24_inventoryAvailabilitySuccess = () => ({
    type: ActionTypes.H24_INVENTORY_AVAILABILITY_SUCCESS
})
export const h24_inventoryAvailabilityFailure = () => ({
    type: ActionTypes.H24_INVENTORY_AVAILABILITY_FAILURE
})

// easyms
export const h24_fetchEasymsCategoriesSuccess = data => ({
    type: ActionTypes.H24_EASYMS_CATEGORIES_FETCH_SUCCESS,
    payload: { ...data }
})
export const h24_fetchEasymsCategoriesFailure = error => ({
    type: ActionTypes.H24_EASYMS_CATEGORIES_FETCH_FAILURE,
    payload: { error }
})
export const h24_fetchEasymsRatesSuccess = data => ({
    type: ActionTypes.H24_EASYMS_RATES_FETCH_SUCCESS,
    payload: { ...data }
})
export const h24_fetchEasymsRatesFailure = error => ({
    type: ActionTypes.H24_EASYMS_RATES_FETCH_FAILURE,
    payload: { error }
})




// WEBPACK FOOTER //
// ./src/actions/hotels24actions.js